import * as z from "zod";
import type { BrandKitFlatTeamSettingKey } from "./catalog";

/** Compile-pinned to the catalog: a key here with no catalog entry is a type
 *  error, and vice versa. */
export const BrandKitFlatTeamSettingsShape = {
  "brandKit/images/logoUrl": z.string().nullish(),
} as const satisfies Record<BrandKitFlatTeamSettingKey, z.ZodTypeAny>;

export const BrandKitFlatTeamSettingsSchema = z.object(
  BrandKitFlatTeamSettingsShape,
);
